var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserDashboardActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2372_5114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4141 1.83594V0.585938H6.91406V1.83594H4.41406V3.08594H3.16406V20.5859H18.1641V19.3359H19.4141V1.83594H14.4141ZM8.16406 1.83594H13.1641V4.33594H8.16406V1.83594ZM16.9141 19.3359H4.41406V4.33594H6.91406V5.58594H14.4141V4.33594H16.9141V19.3359Z",
    fill: "#9C4900",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 8.08594C7.53906 8.08594 9.03906 12.0859 9.03906 12.0859C9.41406 12.5859 9.91406 12.5859 9.91406 12.8359C9.91406 13.2109 9.53906 13.2109 9.16406 13.3359C8.53906 13.4609 8.03906 13.2109 7.41406 14.3359C7.03906 14.8359 6.91406 16.8359 6.91406 16.8359H14.4141C14.4141 16.8359 14.2891 14.8359 13.9141 14.3359C13.4141 13.3359 12.7891 13.4609 12.1641 13.3359C11.7891 13.3359 11.4141 13.2109 11.4141 12.8359C11.4141 12.4609 11.7891 12.5859 12.1641 12.0859C12.2891 12.0859 13.7891 8.08594 10.6641 8.08594Z",
    fill: "#9C4900",
    fillOpacity: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2372_5114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.664062 0.585938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDashboardActive);
export default __webpack_public_path__ + "static/media/UserDashboard_active.90e2ba7bf87794f26ae72380f09c9fba.svg";
export { ForwardRef as ReactComponent };